import { render } from "./FamilyClubUserRegisterConfirmEmailFormApp.vue?vue&type=template&id=5ed1e212"
import script from "./FamilyClubUserRegisterConfirmEmailFormApp.vue?vue&type=script&lang=js"
export * from "./FamilyClubUserRegisterConfirmEmailFormApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__